module.exports = __webpack_public_path__ + "img/new-vac-pan.5b18dd4b.png";